import {Link} from "react-router-dom";
import {BaseButton, BaseCard} from "@/components";
import {PATHS} from "@/constants/routes";
import {useAuthStore} from "@/store/auth.store";

interface FeaturedTile {
  title: string;
  description: string;
  to: string;
  emoji: string;
}

const featuredTiles: readonly FeaturedTile[] = [
  {title: "Casino", description: "Slots, ruleta, blackjack y más", to: PATHS.casino, emoji: "🎰"},
  {title: "Deportes", description: "Apuesta en vivo y pre-partido", to: PATHS.sports, emoji: "⚽"},
  {title: "Bingo", description: "Cartones en vivo 24/7", to: PATHS.bingo, emoji: "🎱"},
  {title: "Hipismo", description: "Ejemplares y jornadas", to: PATHS.horses, emoji: "🐎"},
  {title: "Rifas", description: "Premios diarios", to: PATHS.raffles, emoji: "🎟️"},
  {title: "Lotería", description: "Todos los sorteos", to: PATHS.lottery, emoji: "🎱"},
];

const HomePage = () => {
  const status = useAuthStore(state => state.status);
  const isAuthenticated = status === "authenticated";

  return (
    <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-10 px-4 py-10 text-[var(--color-text)]">
      <section className="flex flex-col items-center gap-4 text-center">
        <span className="rounded-full bg-[var(--color-primary)] px-4 py-1 text-[var(--font-body)] font-bold uppercase tracking-wider text-[var(--color-text-inverse)]">
          ¡Bienvenido!
        </span>
        <h1 className="m-0 text-[var(--font-display)] font-bold leading-tight md:text-[var(--font-display)]">
          Juega, gana y gana
        </h1>
        <p className="m-0 max-w-[640px] text-[var(--font-h3)] text-[var(--color-text-secondary)]">
          Casino, deportes, bingo e hipismo — todo en un solo lugar con pagos instantáneos.
        </p>
        {!isAuthenticated && (
          <div className="mt-2 flex flex-wrap items-center justify-center gap-3">
            <Link to={PATHS.authRegister}>
              <BaseButton
                variant="primary"
                size="lg"
              >
                Crear cuenta
              </BaseButton>
            </Link>
            <Link to={PATHS.authLogin}>
              <BaseButton
                variant="ghost"
                size="lg"
              >
                Iniciar sesión
              </BaseButton>
            </Link>
          </div>
        )}
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="m-0 text-[var(--font-h2)] font-bold">Categorías destacadas</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {featuredTiles.map(tile => (
            <Link
              key={tile.to}
              to={tile.to}
              className="no-underline"
            >
              <BaseCard
                variant="surface"
                padding="lg"
                interactive
              >
                <div className="flex items-start gap-4">
                  <span
                    className="text-[var(--font-display)]"
                    aria-hidden="true"
                  >
                    {tile.emoji}
                  </span>
                  <div className="flex flex-col gap-1">
                    <h3 className="m-0 text-[var(--font-h2)] font-bold text-[var(--color-text)]">{tile.title}</h3>
                    <p className="m-0 text-[var(--font-body-lg)] text-[var(--color-text-secondary)]">
                      {tile.description}
                    </p>
                  </div>
                </div>
              </BaseCard>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default HomePage;
